/*
 * File: \index.js
 * File Created: 2022-04-08 00:12:49
 * Author: Li Haifeng
 * -----
 * Last Modified: 2022-11-22 18:39:19
 * Modified By: Ocean Li ���
 */
import MxGenerator from "./lib/mxGenerator";
import configAPI from "./lib/configAPI.js";
import log from "./lib/log.js";
import util from "./lib/util.js";
import validate from "./lib/validate.js";
import Native from "./lib/native.js";
import NativeLoad from "./lib/nativeLoad.js";
import config from "./config.js";
import MxEvent from "./lib/event.js";

const nativeLoad = new NativeLoad();

// opts: { apis, useNative, useNativeTemp, nativeApis }
// nativeApis: e.g. export default [ ["MideaUser", "getContact"] ]
export default class ModuleCore {
  constructor(opts) {
    this.mxGenerator = new MxGenerator(opts.apis);

    const event = new MxEvent();
    // 添加全局的事件处理api
    this.mxGenerator.setGlobalApi("$triger", event.triger);
    this.mxGenerator.setGlobalApi("$on", event.on);
    this.mxGenerator.setGlobalApi("$off", event.off);
    this.mxGenerator.setGlobalApi("isInMideaConnect", () => {
      return navigator.userAgent.toLowerCase().indexOf('mideaconnect') >= 0
    })

    // 需要使用底座能力
    if (opts.useNative || opts.useNativeTemp) {
      if (!window.hasOwnProperty(config.cordovaInstance) ||
        !window[config.cordovaInstance]
      ) {
        window[config.cordovaInstance] = new Native(opts.nativeApis, event);
      } else {
        window[config.cordovaInstance].addApis(opts.nativeApis);
      }

      if (
        !window.hasOwnProperty(config.cordovaReady) ||
        !window[config.cordovaReady] ||
        window[config.cordovaReady] !== "1"
      ) {
        if (opts.useNative) {
          nativeLoad.loadCordova().then(() => {
            if (window[config.cordovaInstance]) {
              window[config.cordovaInstance].execApis();
            }
          }, () => {});
        } else if (opts.useNativeTemp) {
          nativeLoad.loadCordova(true).then(() => {
            if (window[config.cordovaInstance]) {
              window[config.cordovaInstance].execApis();
            }
          }, () => {});
        }
      }

      if (window.hasOwnProperty(config.cordovaInstance) && window[config.cordovaInstance]) {
        this.nativeApis = window[config.cordovaInstance].api;
      } else {
        window[config.cordovaInstance] = { api: null };
      }
      this.native = window[config.cordovaInstance];
    }
  }
}

const tools = {
  configAPI,
  ...log,
  ...util,
  ...validate,
};

export { tools };
